import {isMatchMedia} from '%helpers%/utils';
import {hideLoading, resetField, showLoading, validateField} from '%helpers%/helpers';
import {debounce} from 'lodash';

export const initiateFormRate = widget => {
  if (!widget) return;

  const form = widget.querySelector('form');
  if (!form) return;
  const isApi = widget.getAttribute('data-use-api') === 'true' || false;
  const isStepsMode = widget.classList.contains('with-steps');
  let activeStep = 1;

  const formBody = form.querySelector('.form-body');
  const formSuccess = form.querySelector('.form-success');
  const submitBtn = form.querySelector(".btn[type='submit']");
  const resetBtn = form.querySelector(".btn[data-action='reset']");

  const modalWrapper = widget.closest('.modal');
  const modal = modalWrapper && bootstrap.Modal.getOrCreateInstance(modalWrapper);

  const offcanvasWrapper = widget.closest('.widget-offcanvas');
  const offcanvas = offcanvasWrapper && bootstrap.Offcanvas.getOrCreateInstance(offcanvasWrapper);

  const formFieldSelectors =
    'input.form-control, input.input-control, textarea.form-control, select.select-control, .radio-group input[type="radio"]';

  const validateWrapper = (wrapper, markInvalid = false) => {
    const fields = wrapper.querySelectorAll(
      'input.form-control, input.input-control, textarea.form-control, select.select-control, .radio-group input[type="radio"]'
    );

    let allValid = true;

    fields.forEach(input => {
      const valid = validateField(input, markInvalid);
      if (!valid) allValid = false;
    });

    return allValid;
  };

  const validateForm = (markInvalid = false) => {
    const valid = validateWrapper(form, markInvalid);
    if (submitBtn) submitBtn.disabled = !valid;
    return valid;
  };

  const validateStep = (step, markInvalid = false) => {
    if (!step) return;
    step = Number(step);
    if (Number.isNaN(step)) return false;
    const stepWrapper = widget.querySelector(`.tab-pane[data-step="${step}"]`);
    if (!stepWrapper) return;

    const valid = validateWrapper(stepWrapper, markInvalid);
    const nextBtn = stepWrapper.querySelector(`[data-action="changeStep"][data-step="${step + 1}"]`);
    const nextTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${step + 1}"]`);

    if (nextBtn) nextBtn.disabled = !valid;
    if (nextTab) nextTab.disabled = !valid;

    return valid;
  };

  const resetForm = () => {
    form.querySelectorAll(formFieldSelectors).forEach(resetField);
    form.reset();

    if (submitBtn) submitBtn.disabled = true;
    hideSuccessMessage();

    if (modal) modal.hide();
    if (offcanvas) offcanvas.hide();

    if (isStepsMode) {
      activeStep = 1;
      changeStep(1);
    }
  };

  const showSuccessMessage = firstName => {
    if (!formSuccess) return;

    const firstNameField = formSuccess.querySelector('[data-value="firstName"]');
    if (firstNameField) firstNameField.textContent = firstName || '';

    if (modal || offcanvas || isMatchMedia('desktop')) {
      formSuccess.style.minHeight = `${formBody.offsetHeight}px`;
    }

    formBody.classList.add('d-none');
    formSuccess.classList.add('show');
    widget.classList.add('is-submitted');
  };

  const hideSuccessMessage = () => {
    if (!formSuccess) return;
    if (modal || offcanvas || isMatchMedia('desktop')) formSuccess.style.minHeight = '';
    formBody.classList.remove('d-none');
    formSuccess.classList.remove('show');
    widget.classList.remove('is-submitted');
  };

  const attachValidationHandlers = (wrapper, step = null) => {
    const handler = debounce(() => {
      if (isStepsMode && step) {
        validateStep(step);
      } else {
        validateForm();
      }
    }, 250);

    wrapper.addEventListener('input', e => {
      if (!e.target.matches(formFieldSelectors)) return;
      e.target.dataset.touched = 'true';
      handler();
    });

    wrapper.addEventListener('change', e => {
      if (!e.target.matches(formFieldSelectors)) return;
      e.target.dataset.touched = 'true';
      handler();
    });

    wrapper.addEventListener(
      'blur',
      e => {
        if (!e.target.matches(formFieldSelectors)) return;
        e.target.dataset.touched = 'true';
        handler();
      },
      true
    );
  };

  const submitForm = async e => {
    e.preventDefault();

    if (!validateForm()) return;

    const formData = new FormData(form);

    showLoading(form);

    try {
      await new Promise(res => setTimeout(res, 800));
      showSuccessMessage(formData.get('firstName'));
    } catch (error) {
      console.error('Form submit error:', error);
    } finally {
      hideLoading();
    }
  };
  const sliderJs = widget.querySelector('.js-range-slider');

  const changeStep = async step => {
    if (activeStep === step) return;
    activeStep = step;
    const nSteps = widget.querySelectorAll('[data-bs-toggle="tab"][data-step]')?.length || 0;
    if (step >= nSteps && isApi) {
      const formData = new FormData(form);
      const formObjData = Object.fromEntries(formData.entries());
      const data = await fetchData();
      updateContactCard(formObjData);
      updateLoanCards(data);
    }
    const tab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${step}"]`);
    if (tab) bootstrap.Tab.getOrCreateInstance(tab).show();
  };

  const fetchData = async () => {
    const formData = new FormData(form);

    // Convert to plain object
    const data = Object.fromEntries(formData.entries());

    // Optional: add custom fields or transform numeric values
    // data.amount = parseFloat(data.amount || 0);

    showLoading(form);

    try {
      const response = await fetch('/umbraco/surface/loanapi/GetLoanOptions', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = response.json();
      hideLoading();

      return result;
    } catch (error) {
      console.error('Error fetching loan options:', error);
      hideLoading();
    }
  };

  if (isStepsMode) {
    const tabs = widget.querySelectorAll('[data-bs-toggle="tab"][data-step]');
    const steps = widget.querySelectorAll('.tab-pane[data-step]');
    steps.forEach(stepEl => {
      const id = stepEl.id;
      const {step, stepValidation} = stepEl.dataset;
      const tab = document.querySelector(
        `[data-bs-target="#${id}"][data-bs-toggle="tab"][data-step="${step}"]`
      );

      if (stepValidation) {
        validateStep(step);
        attachValidationHandlers(stepEl, step);
      }
      if (Number(step) > 1 && tab) tab.disabled = true;
    });

    form.querySelectorAll('[data-action="changeStep"][data-step]').forEach(btn => {
      btn.addEventListener('click', e => {
        const nextStep = Number(btn.dataset.step);
        const currentStep = activeStep;

        if (nextStep > currentStep) {
          const valid = validateStep(currentStep, true);
          if (!valid) return;
        }

        changeStep(nextStep);
      });
    });

    widget.addEventListener('shown.bs.tab', e => {
      const {step} = e.target.dataset;
      activeStep = Number(step);
    });
    widget.addEventListener('hidden.bs.tab', e => {
      tabs.forEach(tabEl => {
        const {step} = tabEl.dataset;
        const valid = validateStep(step);
        tabEl.classList.toggle('completed', valid);
      });
    });
  } else {
    resetForm();
    attachValidationHandlers(form);
    form.addEventListener('submit', submitForm);
  }

  resetBtn?.addEventListener('click', resetForm);
  let debounceTimer;
  if (sliderJs && isApi) {
    sliderJs.noUiSlider.on('set', function (values, handle) {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(async () => {
        const data = await fetchData();
        updateLoanCards(data);
      }, 300);
    });
  }
  modalWrapper && modalWrapper.addEventListener('hidden.bs.modal', resetForm);
  offcanvasWrapper && offcanvasWrapper.addEventListener('hidden.bs.offcanvas', resetForm);

  const years = form.querySelectorAll('[data-field="term-list"] input[type="radio"]');
  years.forEach(year => {
    year.addEventListener('change', e => {
      const cardGroup = year.closest('.card-list-group');
      const paymentLabels = cardGroup.querySelectorAll('data[data-value]');
      paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
      const selected = cardGroup.querySelector(`data[data-value="${e.target.value}"]`);
      if (selected) {
        selected.classList.remove('d-none');
      }
    });
  });

  function updateLoanCards(data) {
    data.forEach(option => {
      const scenario = option.scenario;
      const card = widget.querySelector(`[data-scenario="${scenario}"]`);
      if (!card) return;

      if (scenario === 'FIXED_HELOC') {
        const eligible = option.eligible || {};
        const products = eligible.products || [];
        if (!products.length) {
          // Clear fields if nothing available
          const drawEl = card.querySelector('[data-field="draw-amount"]');
          if (drawEl) drawEl.textContent = '-';
          const paymentEl = card.querySelector('[data-field="monthly-payment"]');
          if (paymentEl) paymentEl.textContent = '-';
          const subtextEl = card.querySelector('[data-field="subtext"]');
          if (subtextEl) subtextEl.textContent = 'No products available';
          return;
        }

        const product = products[0]; // primary product to display
        const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
        const rate = product.rate;
        // Draw Amount
        const drawEl = card.querySelector('[data-field="draw-amount"]');
        if (drawEl) {
          drawEl.textContent = totalLoanAmount != null ? `$${Number(totalLoanAmount).toLocaleString()}` : '-';
        }

        // Monthly Payment — pick best available field
        // const monthlyValue = product.totalPayment ?? product.principalAndInterest ?? product.monthlyMI ?? 0;

        const termWrapper = card.querySelector('[data-term-container]');
        const years = termWrapper.querySelectorAll('input[type="radio"]');

        years.forEach(year => {
          const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, Number(year.value));
          const paymentEl = card.querySelector(`[data-value="${year.value}"][data-field="monthly-payment"]`);
          if (paymentEl) {
            paymentEl.textContent =
              monthlyValue && monthlyValue > 0
                ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
                : '-';
          }
        });
        // const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, 30);
        // const paymentEl = card.querySelector('[data-field="monthly-payment"]');
        // if (paymentEl) {
        //   paymentEl.textContent =
        //     monthlyValue && monthlyValue > 0
        //       ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
        //       : '-';
        // }

        // Terms — show only if there are multiple terms
        const termContainer = card.querySelector('[data-field="term-list"]'); // element where badges go
        // if (termContainer) {
        //   const terms = Array.from(new Set(products.map(p => p.loanTerm).filter(Boolean)));
        //   if (terms.length > 1) {
        //     termContainer.innerHTML = terms
        //       .map(t => {
        //         const label = termLabelFromLoanTerm(t);
        //         return `<span class="badge bg-light text-dark me-1">${label}</span>`;
        //       })
        //       .join('');
        //     if (termWrapper) termWrapper.classList.remove('d-none');
        //   } else {
        //     // hide the whole term row when only one (or none)
        //     if (termWrapper) termWrapper.classList.add('d-none');
        //   }
        // }

        // Footer / Subtext — compose using best available fields
        const subtextEl = card.querySelector('[data-field="subtext"]');
        if (subtextEl) {
          const parts = [];
          if (product.rate != null) parts.push(`Rate: <strong>${product.rate}%</strong>`);
          if (product.apr != null) parts.push(`APR: <strong>${product.apr}%</strong>`);
          if (product.investor) parts.push(product.investor);
          if (product.amortizationType) parts.push(`Type: ${product.amortizationType}`);
          // Fallback if nothing meaningful:
          subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
        }
      } else if (scenario === 'HELOAN') {
        const eligible = option.eligible || {};
        const products = eligible.products || [];
        if (!products.length) {
          // Clear fields if nothing available
          const drawEl = card.querySelector('[data-field="draw-amount"]');
          if (drawEl) drawEl.textContent = '-';
          const paymentEl = card.querySelector('[data-field="monthly-payment"]');
          if (paymentEl) paymentEl.textContent = '-';
          const subtextEl = card.querySelector('[data-field="subtext"]');
          if (subtextEl) subtextEl.textContent = 'No products available';
          return;
        }

        const product = products[0]; // primary product to display
        const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
        const rate = product.rate;
        // Draw Amount
        const drawEl = card.querySelector('[data-field="draw-amount"]');
        if (drawEl) {
          drawEl.textContent = totalLoanAmount != null ? `$${Number(totalLoanAmount).toLocaleString()}` : '-';
        }

        // Monthly Payment — pick best available field
        // const monthlyValue = product.totalPayment ?? product.principalAndInterest ?? product.monthlyMI ?? 0;

        const termWrapper = card.querySelector('[data-term-container]');
        const years = termWrapper.querySelectorAll('input[type="radio"]');

        years.forEach(year => {
          const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, Number(year.value));
          const paymentEl = card.querySelector(`[data-value="${year.value}"][data-field="monthly-payment"]`);
          if (paymentEl) {
            paymentEl.textContent =
              monthlyValue && monthlyValue > 0
                ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
                : '-';
          }
        });
        // const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, 30);
        // const paymentEl = card.querySelector('[data-field="monthly-payment"]');
        // if (paymentEl) {
        //   paymentEl.textContent =
        //     monthlyValue && monthlyValue > 0
        //       ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
        //       : '-';
        // }

        // Terms — show only if there are multiple terms
        const termContainer = card.querySelector('[data-field="term-list"]'); // element where badges go
        // if (termContainer) {
        //   const terms = Array.from(new Set(products.map(p => p.loanTerm).filter(Boolean)));
        //   if (terms.length > 1) {
        //     termContainer.innerHTML = terms
        //       .map(t => {
        //         const label = termLabelFromLoanTerm(t);
        //         return `<span class="badge bg-light text-dark me-1">${label}</span>`;
        //       })
        //       .join('');
        //     if (termWrapper) termWrapper.classList.remove('d-none');
        //   } else {
        //     // hide the whole term row when only one (or none)
        //     if (termWrapper) termWrapper.classList.add('d-none');
        //   }
        // }

        // Footer / Subtext — compose using best available fields
        const subtextEl = card.querySelector('[data-field="subtext"]');
        if (subtextEl) {
          const parts = [];
          if (product.rate != null) parts.push(`Rate: <strong>${product.rate}%</strong>`);
          if (product.apr != null) parts.push(`APR: <strong>${product.apr}%</strong>`);
          if (product.investor) parts.push(product.investor);
          if (product.amortizationType) parts.push(`Type: ${product.amortizationType}`);
          // Fallback if nothing meaningful:
          subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
        }
      } else if (scenario === 'VARIABLE_HELOC') {
        const eligible = option.eligible || {};
        const products = eligible.products || [];
        if (!products.length) {
          // Clear fields if nothing available
          const drawEl = card.querySelector('[data-field="draw-amount"]');
          if (drawEl) drawEl.textContent = '-';
          const paymentEl = card.querySelector('[data-field="monthly-payment"]');
          if (paymentEl) paymentEl.textContent = '-';
          const subtextEl = card.querySelector('[data-field="subtext"]');
          if (subtextEl) subtextEl.textContent = 'No products available';
          return;
        }

        const product = products[0]; // primary product to display
        const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
        const rate = product.rate;
        // Draw Amount
        const drawEl = card.querySelector('[data-field="draw-amount"]');
        if (drawEl) {
          drawEl.textContent = totalLoanAmount != null ? `$${Number(totalLoanAmount).toLocaleString()}` : '-';
        }

        // Monthly Payment — pick best available field
        // const monthlyValue = product.totalPayment ?? product.principalAndInterest ?? product.monthlyMI ?? 0;

        const termWrapper = card.querySelector('[data-term-container]');
        const years = termWrapper.querySelectorAll('input[type="radio"]');

        years.forEach(year => {
          const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, Number(year.value));
          const paymentEl = card.querySelector(`[data-value="${year.value}"][data-field="monthly-payment"]`);
          if (paymentEl) {
            paymentEl.textContent =
              monthlyValue && monthlyValue > 0
                ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
                : '-';
          }
        });
        // const monthlyValue = calculateMonthlyPayment(totalLoanAmount, rate, 30);
        // const paymentEl = card.querySelector('[data-field="monthly-payment"]');
        // if (paymentEl) {
        //   paymentEl.textContent =
        //     monthlyValue && monthlyValue > 0
        //       ? `$${Number(monthlyValue).toLocaleString(undefined, {maximumFractionDigits: 2})}`
        //       : '-';
        // }

        // Terms — show only if there are multiple terms
        const termContainer = card.querySelector('[data-field="term-list"]'); // element where badges go
        // if (termContainer) {
        //   const terms = Array.from(new Set(products.map(p => p.loanTerm).filter(Boolean)));
        //   if (terms.length > 1) {
        //     termContainer.innerHTML = terms
        //       .map(t => {
        //         const label = termLabelFromLoanTerm(t);
        //         return `<span class="badge bg-light text-dark me-1">${label}</span>`;
        //       })
        //       .join('');
        //     if (termWrapper) termWrapper.classList.remove('d-none');
        //   } else {
        //     // hide the whole term row when only one (or none)
        //     if (termWrapper) termWrapper.classList.add('d-none');
        //   }
        // }

        // Footer / Subtext — compose using best available fields
        const subtextEl = card.querySelector('[data-field="subtext"]');
        if (subtextEl) {
          const parts = [];
          if (product.rate != null) parts.push(`Rate: <strong>${product.rate}%</strong>`);
          if (product.apr != null) parts.push(`APR: <strong>${product.apr}%</strong>`);
          if (product.investor) parts.push(product.investor);
          if (product.amortizationType) parts.push(`Type: ${product.amortizationType}`);
          // Fallback if nothing meaningful:
          subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
        }
      }
    });
  }

  function calculateMonthlyPayment(P, annualRate, years) {
    const i = annualRate / 100 / 12;
    const N = years * 12;
    return (P * (i * Math.pow(1 + i, N))) / (Math.pow(1 + i, N) - 1);
  }

  function updateContactCard(data) {
    const card = widget.querySelector('.widget-card_contacts');
    if (!card) return;

    const fields = {
      name: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
      address: formatAddress(data),
      email: data.email || data.email_address || '—',
      fico: data.creditScore || data.credit_score_range || '—',
      'property-value': formatCurrency(data.property_value),
      'amount-owed': formatCurrency(data.first_mortgage_balance),
    };

    for (const [key, value] of Object.entries(fields)) {
      const el = card.querySelector(`[data-field="${key}"]`);
      if (el) el.textContent = value || '—';
    }
  }

  function formatAddress(data) {
    const parts = [data.property_address, data.property_city, data.property_state, data.property_zip].filter(
      Boolean
    );
    return parts.join(', ');
  }

  function formatCurrency(value) {
    if (!value) return '—';
    const num = parseFloat(value.replace(/,/g, ''));
    if (isNaN(num)) return value;
    return `$${num.toLocaleString()}`;
  }

  function termLabelFromLoanTerm(term) {
    if (!term) return term;

    // If it contains digits, take them
    const digitMatch = term.match(/\d+/);
    if (digitMatch) return digitMatch[0];

    // fallback map for word-number tokens
    const map = {
      Ten: '10',
      Twenty: '20',
      Thirty: '30',
      Fifteen: '15',
      Five: '5',
    };

    // try to extract a known word
    for (const [word, val] of Object.entries(map)) {
      if (term.toLowerCase().includes(word.toLowerCase())) return val;
    }

    // last resort: strip non-digits and return the raw string
    return term.replace(/[^0-9]/g, '') || term;
  }
  initStickyPosition(widget);
};

function initStickyPosition(widget) {
  const wrapper = widget.closest('.hero-media.js-position-sticky');
  if (!wrapper) return;

  const pageHeader = document.querySelector('.page-header');
  const sectionWithOffset = document.querySelector('.widget-wrapper.with-form-offset');
  const stopSection = sectionWithOffset?.nextElementSibling || document.querySelector('.page-footer');

  let ticking = false;
  let paddingBottom = calcPadding();

  function calcPadding() {
    return sectionWithOffset ? parseFloat(getComputedStyle(sectionWithOffset).paddingBottom) : 60;
  }

  function update() {
    if (isMatchMedia('xl-down')) {
      wrapper.classList.remove('position-fixed', 'position-absolute');
      wrapper.style.top = '';
      ticking = false;
      return;
    }

    const headerHeight = pageHeader?.offsetHeight || 0;
    const scrollY = window.scrollY;
    const stopTop = stopSection
      ? stopSection.getBoundingClientRect().top + scrollY
      : document.body.scrollHeight;
    const stopScroll = stopTop - wrapper.offsetHeight - paddingBottom * 2;
    const stopped = scrollY >= stopScroll;

    wrapper.classList.toggle('position-fixed', !stopped);
    wrapper.classList.toggle('position-absolute', stopped);
    wrapper.style.top = stopped
      ? `${Math.round(stopScroll)}px`
      : `calc(${Math.round(headerHeight)}px + var(--bs-widget-hero-padding-y))`;

    ticking = false;
  }

  function onScrollOrResize() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScrollOrResize, {passive: true});
  window.addEventListener(
    'resize',
    () => {
      paddingBottom = calcPadding();
      onScrollOrResize();
    },
    {passive: true}
  );
}
